import { own } from '../content.js'
import Icon from '../components/Icon.jsx'

export default function Own() {
  return (
    <section className="section" id="own">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">{own.eyebrow}</span>
          <h2>{own.title}</h2>
        </div>
        <div className="versus">
          {[own.them, own.us].map((col, i) => (
            <div key={col.title} className={`versus-col ${i ? 'is-us' : ''}`}>
              <h3>{col.title}</h3>
              <p className="versus-sub">{col.sub}</p>
              <ul className="checks">
                {col.points.map((p) => <li key={p}><Icon name={i ? 'check' : 'x'} size={18} />{p}</li>)}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
